import {
  useGfmExperimentExposure,
  useHubSpotWidget,
  usePageViewTracking,
  usePlausible,
  useSignUpAttribution,
  useUtmParams
} from '@percent/cause-dashboard/common/hooks'
import { NotificationBarContextController } from '../context/notificationBar/notificationBarController/NotificationBarContextController'
import { PromotionalPopupContextController } from '../context/promotionalPupup/promotionalPopupController/PromotionalPopupContextController'
import '@mantine/dates/styles.css'
import '@mantine/core/styles.css'
import './App.scss'
import SitewideMessage from './layout/sitewideMessage/SitewideMessage'
import { AppProviders } from './providers/AppProviders'
import { Routes } from './routes/Routes'
import { SitewideMessageContextController } from '../context/sitewideMessage/sitewideMessageController/SitewideMessageContextController'
import { BreadcrumbsContextController } from './layout/breadcrumbsContext/breadcrumbsContextController/BreadcrumbsContextController'
import { NativeApplyModalProvider } from '@percent/cause-dashboard/common/components/nativeApply'
import { EnvironmentOverlay } from '@percent/shared/environment-overlay'

export function App() {
  useHubSpotWidget()
  usePlausible()
  useUtmParams()
  useSignUpAttribution()
  usePageViewTracking()
  useGfmExperimentExposure()

  return (
    <AppProviders>
      <BreadcrumbsContextController>
        <PromotionalPopupContextController>
          <SitewideMessageContextController>
            <NotificationBarContextController>
              <NativeApplyModalProvider>
                <EnvironmentOverlay />
                <SitewideMessage />
                <Routes />
              </NativeApplyModalProvider>
            </NotificationBarContextController>
          </SitewideMessageContextController>
        </PromotionalPopupContextController>
      </BreadcrumbsContextController>
    </AppProviders>
  )
}
